import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { cx } from '@platform/core/lib/cx';
import type { IPickerListProps } from './IPickerListProps';
import { PickerOptionRow } from './PickerOptionRow';

/**
 * Плаваючий список пікера в порталі (UIUX/controls/picker): fixed під полем, мін. ширина поля, ширина за вмістом до 360px
 * (ключовий рядок — 320px), висота до 300px, радіус 10, тінь 0 14px 32px; пошук 32px на --surface2 над пунктами; «Збігів немає»;
 * підвал (лічильник і дії). Виділений пункт прокручується в поле зору.
 */
export function PickerList({ listId, panelRef, pos, label, options, value, hi, onPick, onHover, search, emptyText, loading, footer, compact, className }: IPickerListProps) {
  useEffect(() => {
    if (hi < 0) return;
    document.getElementById(`${listId}-o${hi}`)?.scrollIntoView({ block: 'nearest' });
  }, [hi, listId]);
  return createPortal(
    <div ref={panelRef} className={cx('pk-list', compact && 'pk-list--compact', className)}
      style={{ left: pos.left, top: pos.top, bottom: pos.bottom, minWidth: pos.minWidth }}>
      {search && (
        <input className="pk-list__search" autoFocus value={search.value} placeholder={search.placeholder} aria-label={search.label}
          aria-controls={listId} aria-activedescendant={hi >= 0 ? `${listId}-o${hi}` : undefined} autoComplete="off" spellCheck={false}
          onChange={(e) => search.onChange(e.target.value)} onKeyDown={search.onKeyDown} onBlur={search.onBlur} />
      )}
      <div id={listId} role="listbox" aria-label={label} className="pk-list__options">
        {options.map((o, i) => (
          <PickerOptionRow key={o.value || `_${i}`} id={`${listId}-o${i}`} option={o} selected={o.value === value && value !== ''}
            active={i === hi} onPick={() => onPick(o)} onHover={() => onHover(i)} />
        ))}
      </div>
      {!options.length && <div className="pk-list__empty">{loading ? '…' : emptyText}</div>}
      {footer && <div className="pk-list__foot">{footer}</div>}
    </div>,
    document.body,
  );
}
